// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import setTableColumns from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetTableColumns";
import setView from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetView";
import setVisibleColumnNames from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetVisibleColumnNames";
import {
    getProductListDataView,
    isLoadMore,
} from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { ProductListViewType } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import CardContainerMultiColumn, {
    CardContainerMultiColumnStyles,
} from "@insite/content-library/Components/CardContainerMultiColumn";
import CardList, { CardListStyles } from "@insite/content-library/Components/CardList";
import { ProductListPageDataContext } from "@insite/content-library/Pages/ProductListPage";
import ProductListProductCard from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import ProductListProductContext from "@insite/content-library/Widgets/ProductList/ProductListProductContext";
// import ProductListProductGridCard from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard"; // Store Custom Code
import ProductListTable from "@insite/content-library/Widgets/ProductList/ProductListTable";
// import Button, { ButtonPresentationProps } from "@insite/mobius/Button"; // Starter Custom Code
import Hidden from "@insite/mobius/Hidden";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
// import { TypographyPresentationProps } from "@insite/mobius/Typography"; // Starter Custom Code
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import sortBy from "lodash/sortBy";
import React, { ReactNode, useCallback, useEffect, useRef } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import Loader from "@store/Library/Components/Toolkit/Loader";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import { productListPaginationWrapperStyles } from "@store/Themes/common/mixins/productList";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import getMatchingDataFromDictionary from "@toolkit/Framework/Common/Utilities/getMatchingDataFromDictionary";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useBrandName, useSearchQuery } from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListHooks";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

// Foundation --->
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Foundation

// Sas --->
import ProductListProductGridCard from "@store/Overrides/Widgets/ProductList/ProductListProductGridCard"; // Sas
// <--- Sas

const enum fields {
    showImage = "showImage",
    showCompare = "showCompare",
    showBrand = "showBrand",
    showTitle = "showTitle",
    showPartNumbers = "showPartNumbers",
    showAvailability = "showAvailability",
    showAttributes = "showAttributes",
    showPrice = "showPrice",
    showAddToList = "showAddToList",
    productListDefaultView = "productListDefaultView",
    showImageBadges = "showImageBadges",
    maximumNumberOfImageBadges = "maximumNumberOfImageBadges",
    showTextBadges = "showTextBadges",
    maximumNumberOfTextBadges = "maximumNumberOfTextBadges",
    // Sas
    showActions = "showActions",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImage]: boolean;
        [fields.showCompare]: boolean;
        [fields.showTitle]: boolean;
        [fields.showBrand]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showAvailability]: boolean;
        [fields.showAttributes]: boolean;
        [fields.showPrice]: boolean;
        [fields.showAddToList]: boolean;
        [fields.productListDefaultView]: ProductListViewType;
        [fields.showImageBadges]: boolean;
        [fields.maximumNumberOfImageBadges]: number;
        [fields.showTextBadges]: boolean;
        [fields.maximumNumberOfTextBadges]: number;
        // Sas
        [fields.showActions]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        pages: {
            productList: {
                isLoading,
                isSearchPage,
                view,
                productFilters: { pageCategoryId },
                parameter,
                productInfosByProductId, // Starter Custom Code
            },
        },
    } = state;

    const {
        websiteSettings: { includeRealTimeInventoryAndPricingForSeo },
        productSettings: { productLoadStyle },
    } = getSettingsCollection(state);

    /* Starter Custom Code - Start */
    const productsDataView = getProductListDataView(state);
    const productContexts = productsDataView.value?.map(product => {
        return {
            product,
            productInfo: state.pages.productList.productInfosByProductId[product.id],
        } as ProductContextModel;
    });
    /* Starter Custom Code - End */

    return {
        isLoading,
        productsDataView, // Starter Custom Code
        view: view || ownProps.fields.productListDefaultView,
        isSearchPage,
        attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
        brandFacets: getProductListDataViewProperty(state, "brandFacets"),
        productLineFacets: getProductListDataViewProperty(state, "productLineFacets"),
        includeRealTimeInventoryAndPricingForSeo,
        pageCategoryId,
        productLoadStyle,
        page: parameter?.page ?? 1,
        pageSize: parameter?.pageSize ?? 0,
        totalItemCount: getProductListDataViewProperty(state, "pagination")?.totalItemCount ?? 0,
        isLoadMore: isLoadMore(state),
        // Starter Custom Code
        productContexts,
        productInfosByProductId,
    };
};

const mapDispatchToProps = {
    setView,
    setTableColumns,
    setVisibleColumnNames,
    addProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> &
    OwnProps &
    ResolveThunks<typeof mapDispatchToProps> &
    HasCategoryContext; // Starter Custom Code

export interface ProductListCardListStyles {
    wrapper?: InjectableCss;
    cardList?: CardListStyles;
    noProductsText?: TypographyPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    cardContainerStyles?: CardContainerStyles;
    cardContainerMultiColumnStyles?: CardContainerMultiColumnStyles;
    loadMoreWrapper?: InjectableCss;
    loadMoreButton?: ButtonPresentationProps;
    // Starter Custom Code
    container?: GridContainerProps;
    lineGridItem?: GridItemProps;
}

export const listStyles: ProductListCardListStyles = {
    cardContainerMultiColumnStyles: {
        gridItem: {
            width: [12, 6, 6, 4, 4],
            css: css`
                padding: ${pxToRem(15)};
                flex-shrink: 0;
            `,
        },
        cardDivider: {
            css: css`
                padding: 0;
                height: 100%;
                width: 100%;
            `,
        },
    },
    wrapper: {
        css: css`
            margin-top: 1em;
        `,
    },
    cardList: {
        gridContainer: {
            css: css`
                display: flex;
                justify-content: center;
                align-items: center;
            `,
            gap: 30,
            offsetCss: css`
                margin-bottom: 3em;
                ${breakpointValues(["center", "space-between", "flex-start"], "justify-content")}
            `,
        },
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            height: ${pxToRem(150)};
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noProductsText: {
        variant: "h4",
        css: css`
            display: block;
            margin: auto;
        `,
    },
    cardContainerStyles: {
        cardDivider: {
            css: css`
                width: 100%;
            `,
        },
        gridItem: {
            css: css`
                border: ${pxToRem(1)} solid ${getColor("common.border")};
            `,
        },
    },
};

const styles = listStyles;

const ProductListCardList = ({
    id,
    isLoading,
    isSearchPage,
    productsDataView,
    view,
    fields,
    attributeTypeFacets,
    brandFacets,
    productLineFacets,
    includeRealTimeInventoryAndPricingForSeo,
    pageCategoryId,
    productLoadStyle,
    page,
    pageSize,
    totalItemCount,
    isLoadMore,
    setView,
    setTableColumns,
    setVisibleColumnNames,
    addProductFilters,
    // Starter Custom Code
    productContexts,
    productInfosByProductId,
    category,
}: Props) => {
    useEffect(() => {
        setView({ view });
    }, []);

    /* Starter Removed - useEffect - setTableColumns, setVisibleColumnNames */

    /* Starter Custom Code - Start */
    const brandName = useBrandName();
    const searchQuery = useSearchQuery();
    const brandId = productContexts?.find((x: any) => x.product?.brand?.name === brandName)?.product.brand?.id;
    const productInfos = getMatchingDataFromDictionary(productsDataView.value, productInfosByProductId);

    const trackViewItemList = ga.use.trackViewItemList(
        {
            items: productsDataView.value,
            item_list_name: (brandId ? brandName : category?.id ? category.shortDescription : searchQuery) || undefined,
            item_list_id: brandId ? "brand" : category?.id ? "category" : "search",
        },
        { productInfos },
    );

    ga.use.productInfosCallback(productInfos, trackViewItemList);
    /* Starter Custom Code - End */
    const observer: React.MutableRefObject<any> = useRef();
    const itemsLeft = totalItemCount - page * pageSize;

    const infiniteScrollTriggerRef = useCallback(
        node => {
            if (productLoadStyle !== "InfiniteScroll" || getIsWebCrawler() || isLoading) {
                return;
            }

            if (observer.current) {
                observer.current.disconnect();
            }

            observer.current = new IntersectionObserver(entries => {
                if (entries[0].isIntersecting && itemsLeft > 0) {
                    addProductFilters({ page: page + 1 });
                }
            });

            if (node) {
                observer.current?.observe(node);
            }
        },
        [productLoadStyle, isLoading, itemsLeft],
    );

    const loadMoreClickHandler = () => {
        addProductFilters({ page: page + 1 });
    };

    if (isLoading && !productsDataView.value && !isLoadMore) {
        return <Loader testSelector="productListCardListSpinner" />; // Starter Custom Code
    }

    if (!productsDataView.value) {
        return null;
    }

    const products = productsDataView.value;
    if (products.length === 0) {
        const styledWrapper =
            totalItemCount === 0 ? (
                <StyledWrapper {...styles.wrapper}>
                    <StyledWrapper {...styles.centeringWrapper} data-test-selector="productListNoneFound">
                        {/* Starter Custom Code - Start */}
                        <Typography {...styles.noProductsText}>{translate("There were no products found.")}</Typography>
                        {/* Starter Custom Code - End */}
                    </StyledWrapper>
                </StyledWrapper>
            ) : (
                <Loader testSelector="productListCardListSpinner" /> // Starter Custom Code
            );

        return styledWrapper;
    }

    const renderProducts = (children: ReactNode) => {
        return products.map((product, idx) => (
            <ProductListProductContext product={product} idx={idx} key={product.id}>
                {children}
            </ProductListProductContext>
        ));
    };

    const overriddenProps = { ...fields };
    if (getIsWebCrawler() && !includeRealTimeInventoryAndPricingForSeo) {
        overriddenProps.showAvailability = false;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <ProductListPageDataContext.Consumer>
                {({ ref }) => {
                    return ref ? <span ref={ref} tabIndex={-1} /> : undefined;
                }}
            </ProductListPageDataContext.Consumer>
            <LoadingOverlay loading={isLoading}>
                {/* Store Custom Code */}
                <CardList extendedStyles={styles.cardList} data-test-selector="productListCards_Grid">
                    {renderProducts(
                        <CardContainerMultiColumn extendedStyles={styles.cardContainerMultiColumnStyles}>
                            <ProductListProductGridCard {...overriddenProps} showActions={fields.showActions} />
                        </CardContainerMultiColumn>,
                    )}
                </CardList>
                {/* Store Custom Code */}
            </LoadingOverlay>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCategory(ProductListCardList)), // Starter Custom Code
    definition: {
        group: "Product List",
        displayName: "Card List",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.showImage,
                displayName: "Show Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.showCompare,
                displayName: "Show Compare",
                editorTemplate: "CheckboxField",
                defaultValue: false, // Starter Custom Code
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.showBrand,
                displayName: "Show Brand",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.showTitle,
                displayName: "Show Title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.showPartNumbers,
                displayName: "Show Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 5,
            },
            {
                name: fields.showAvailability,
                displayName: "Show Availability",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 6,
            },
            {
                name: fields.showAttributes,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 7,
            },
            {
                name: fields.showPrice,
                displayName: "Show Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 8,
            },
            {
                name: fields.showAddToList,
                displayName: "Show Add To List",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 9,
            },
            {
                name: fields.productListDefaultView,
                editorTemplate: "RadioButtonsField",
                defaultValue: "Grid", // Starter Custom Code
                fieldType: "General",
                sortOrder: 10,
                options: [
                    {
                        displayName: "List",
                        value: "List",
                    },
                    {
                        displayName: "Grid",
                        value: "Grid",
                    },
                    /* Starter Removed - display Table */
                ],
            },
            {
                name: fields.showImageBadges,
                displayName: "Show Image Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 11,
            },
            {
                name: fields.maximumNumberOfImageBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showImageBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "General",
                sortOrder: 12,
            },
            {
                name: fields.showTextBadges,
                displayName: "Show Text Badges",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 13,
            },
            {
                name: fields.maximumNumberOfTextBadges,
                editorTemplate: "DropDownField",
                isVisible: widget => widget.fields.showTextBadges,
                defaultValue: "4",
                options: [
                    { displayName: "1", value: "1" },
                    { displayName: "2", value: "2" },
                    { displayName: "3", value: "3" },
                    { displayName: "4", value: "4" },
                    { displayName: "5", value: "5" },
                    { displayName: "6", value: "6" },
                    { displayName: "7", value: "7" },
                    { displayName: "8", value: "8" },
                ],
                fieldType: "General",
                sortOrder: 14,
            },
            // Sas --->
            {
                name: fields.showActions,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 13,
            },
            // <--- Sas
        ],
    },
};

export default widgetModule;
